import React from "react";

const VARIANTS = {
  error: {
    container: "bg-red-50 border-red-200 text-red-700",
    icon: "text-red-600",
    title: "Error:",
  },
  success: {
    container: "bg-green-100 border-green-200 text-green-700",
    icon: "text-green-600",
    title: "",
  },
  loading: {
    container: "bg-blue-50 border-blue-200 text-blue-700",
    icon: "text-blue-600",
    title: "",
  },
};

function IconError({ className }) {
  return (
    <svg
      className={className}
      fill="currentColor"
      viewBox="0 0 20 20"
      aria-hidden>
      <path
        fillRule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
        clipRule="evenodd"
      />
    </svg>
  );
}

function Spinner({ className }) {
  return (
    <svg
      className={`animate-spin ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      aria-hidden>
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
}

export default function AlertMessage({ variant = "error", message, title }) {
  const config = VARIANTS[variant] || VARIANTS.error;
  const displayTitle = title ?? config.title;

  return (
    <div
      className={`mb-4 p-4 border rounded-lg ${config.container}`}
      role={variant === "error" ? "alert" : "status"}>
      <div className="flex items-center gap-2">
        {variant === "loading" && <Spinner className="h-5 w-5 flex-shrink-0" />}
        {variant === "error" && (
          <IconError className={`w-5 h-5 flex-shrink-0 ${config.icon}`} />
        )}
        <div className="min-w-0 flex-1">
          {displayTitle && (
            <div className="font-semibold text-xs sm:text-sm">{displayTitle}</div>
          )}
          <div className="text-xs sm:text-sm break-words">{message}</div>
        </div>
      </div>
    </div>
  );
}
